export const addLocalFileInfo = (file, fileIndex) => {
  const fileType = (file.name || file.src || file.imageUri).split('.').slice(-1);

  const imageUri = file.src ? file.src : URL.createObjectURL(file);

  return Object.assign(file, {
    imageUri,
    src: imageUri,
    fileName: `${new Date().getTime()}_${fileIndex}.${fileType}`,
    label: null,
    rotateDegree: 0,
  });
};

export const getImageFile = file => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(
        Object.assign(file, {
          width: img.width,
          height: img.height,
        }),
      );
    };
    img.onerror = error => reject(error);
    img.src = file.src;
  });
};
export const resizeImageFile = (imageObject, { scaleFactor, maxSize }) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imageObject.src;
    img.onload = () => {
      const canvas = document.createElement('canvas');

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }

      // const scaledWidth = img.width * scaleFactor;
      // const scaledHeight = img.height * scaleFactor;

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);

      ctx.canvas.toBlob(
        blob => {
          const updatedFile = new File([blob], imageObject.name, {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });

          resolve(updatedFile);
        },
        'image/jpeg',
        1,
      );
    };
    img.onerror = error => reject(error);
    img.onabort = error => reject(error);
  });
};
